import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

// Page-level wrapper: scroll-to-top on route change + soft fade-in.
export default function PageShell({ children, title, paddingTop = true }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    if (title) document.title = `${title} · DharmaWeave`;
    else document.title = "DharmaWeave · Sacred stories, woven with light.";
  }, [pathname, title]);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={paddingTop ? "pt-24 md:pt-28" : ""}
    >
      {children}
    </motion.main>
  );
}
